import { Injectable } from '@angular/core';
import { MatLegacySnackBar as MatSnackBar, MatLegacySnackBarConfig as MatSnackBarConfig } from '@angular/material/legacy-snack-bar';
import { RibbonComponent } from '@shared/components/ribbon/ribbon.component';
import { RIBBON_TYPE } from '@shared/models/ribbon.model';

@Injectable({
  providedIn: 'root'
})
export class RibbonService {
  private readonly ribbonConfig: MatSnackBarConfig = {
    duration: 5000,
    horizontalPosition: 'start',
    verticalPosition: 'top',
    panelClass: 'ribbon'
  };

  constructor(private readonly snackBar: MatSnackBar) { }

  public openRibbon(type: RIBBON_TYPE, message: string, conf?: MatSnackBarConfig): void {
    this.snackBar.openFromComponent(RibbonComponent, {
      ...this.ribbonConfig,
      ...conf,
      data: {type, message}
    });
  }
}
